var CloseSides = {
  Leading: 'Leading',
  Trailing: 'Trailing'
};
var modalDefaultValues = {
  closeButtonSide: CloseSides.Leading,
  hasDynamicPadding: false,
  titleSize: 32,
  useHairlineDividers: true
};

export { CloseSides, modalDefaultValues };
